import { mapState } from 'vuex'
import isEmpty from 'lodash/isEmpty'

const filtersMixins = {
  computed: {
    ...mapState({
      availablePriceRange: state => state.product.availablePriceRange
    }),

    showPriceRange () {
      return !isEmpty(this.availablePriceRange)
    }
  }
}

export {
  filtersMixins
}
